import React from "react";
import { Container, Description, TextLimit, IsRequired } from "./InputContainer.styled";

export const InputContainer = ({
  id,
  label,
  description,
  maxLen,
  textLen,
  isRequired,
  flex,
  width,
  render
}) => {
  return (
    <Container flex={flex} width={width}>
      {label && (
        <label htmlFor={id}>
          {label}
          {isRequired && <IsRequired>*</IsRequired>}
          {description && <Description>{description}</Description>}
        </label>
      )}
      {textLen ? <TextLimit label={label}>{textLen + `/${maxLen}`}</TextLimit> : null}

      {render(id)}
    </Container>
  );
};
